export const createdFromCIChoises = [
  { id: "MANUALLY_ADMIN", name: "Administrateur" },
  { id: "MANUALLY_CLIENT", name: "Client" },
  { id: "ORDER", name: "BDC" },
];

export const createdFromCIMap: Record<string, "success" | "warning" | "error"> = {
  MANUALLY_ADMIN: "warning",
  MANUALLY_CLIENT: "success",
  ORDER: "error",
};

export const createdFromCILabels: Record<string, string> = createdFromCIChoises.reduce(
  (acc, { id, name }) => ({ ...acc, [id]: name }),
  {}
);
